import { Button, Space } from "antd";
import { useNavigate } from "react-router-dom";

function NavBar() {
  const navigate = useNavigate();
  return (
    <nav>
      <div className="nav-w">
        <h2 id="logo">La Braseria Dashboard</h2>
          <Space size={"large"}>
              <a
                  onClick={() => {
                      navigate("/transazioni");
                  }}
              >
                  Transazioni
              </a>
              <a
                  onClick={() => {
                      navigate("/gift-cards");
                  }}
              >
                  Gift cards
              </a>
              <a
                  onClick={() => {
                      navigate("/obiettivi");
                  }}
              >
                  Obiettivi
              </a>
              <a
                  onClick={() => {
                      navigate("/utenti");
                  }}
              >
                  Utenti
              </a>
              <a
                  onClick={() => {
                      navigate("/");
                  }}
              >
                  Notifiche
              </a>
              <a
                  onClick={() => {
                      navigate("/rapportoEuroPunti");
                  }}
              >
                  Impostazioni
              </a>
              {/*<Button
            type="primary"
            onClick={() => {
              navigate("/crea-notifica");
            }}
          >
            Crea notifica
          </Button>*/}
          </Space>
      </div>
    </nav>
  );
}

export default NavBar;
